import { acceptAccessToken, authApi, api, refreshAccessToken, unwrap } from "@/shared/api/client"
import { clearTokens } from "@/shared/auth/tokenStore"
import type {
  AccessTokenResponse,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  LoginRequest,
  RegisterRequest,
  ResetPasswordRequest,
  UserProfile,
} from "@/shared/api/types"

const getCurrentUser = () => unwrap<UserProfile>(api.GET("/me"))

const establishSession = async (tokens: AccessTokenResponse): Promise<UserProfile> => {
  acceptAccessToken(tokens)
  try {
    return await getCurrentUser()
  } catch (error) {
    clearTokens()
    throw error
  }
}

export const loginAccount = async (body: LoginRequest) =>
  establishSession(await unwrap<AccessTokenResponse>(authApi.POST("/auth/login", { body })))

export const registerAccount = async (body: RegisterRequest) =>
  establishSession(await unwrap<AccessTokenResponse>(authApi.POST("/auth/register", { body })))

export const restoreAccount = async () => {
  await refreshAccessToken()
  return getCurrentUser()
}

export const logoutAccount = () => unwrap<void>(authApi.POST("/auth/logout"))

export const forgotPassword = (body: ForgotPasswordRequest) =>
  unwrap(authApi.POST("/auth/password/forgot", { body }))

export const resetPassword = (body: ResetPasswordRequest) =>
  unwrap<void>(authApi.POST("/auth/password/reset", { body }))

export const changePassword = (body: ChangePasswordRequest) =>
  unwrap<void>(api.POST("/auth/password/change", { body }))
